<div class="bv-ical-modal">
  <header class="bv-ical-modal__header">
    <h2 class="bv-ical-modal__title">{{ 'ALERTS.ONBOARDING.MODAL_TITLE' | translate }}</h2>
    <button type="button" class="bv-ical-modal__close" (click)="onClose()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <p class="bv-ical-modal__lead">{{ 'ALERTS.ONBOARDING.MODAL_LEAD' | translate }}</p>

  @if (!icalUrl) {
    <div class="bv-ical-modal__generate">
      <p class="bv-ical-modal__hint">{{ 'ALERTS.ONBOARDING.MODAL_GENERATE_HINT' | translate }}</p>
      <button class="bv-btn bv-btn--primary"
        [disabled]="generating"
        (click)="onGenerate()">
        @if (generating) {
          <mat-icon class="bv-spinner">sync</mat-icon>
        } @else {
          <mat-icon>link</mat-icon>
        }
        {{ 'ALERTS.ONBOARDING.MODAL_GENERATE_BUTTON' | translate }}
      </button>
    </div>
  } @else {
    <div class="bv-ical-modal__url-row">
      <input type="text" class="form-control bv-ical-modal__url" readonly [value]="icalUrl" />
      <button type="button" class="bv-btn bv-btn--secondary" (click)="onCopy()">
        <mat-icon>content_copy</mat-icon>
        {{ 'BUTTONS.COPY' | translate }}
      </button>
    </div>

    <mat-tab-group class="bv-ical-modal__tabs" animationDuration="0ms">
      <mat-tab [label]="'ALERTS.ONBOARDING.TAB_GOOGLE' | translate">
        <ol class="bv-ical-modal__steps">
          <li>{{ 'ALERTS.ONBOARDING.STEP_GOOGLE_1' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_GOOGLE_2' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_GOOGLE_3' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_GOOGLE_4' | translate }}</li>
        </ol>
      </mat-tab>

      <mat-tab [label]="'ALERTS.ONBOARDING.TAB_OUTLOOK' | translate">
        <ol class="bv-ical-modal__steps">
          <li>{{ 'ALERTS.ONBOARDING.STEP_OUTLOOK_1' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_OUTLOOK_2' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_OUTLOOK_3' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_OUTLOOK_4' | translate }}</li>
        </ol>
      </mat-tab>

      <mat-tab [label]="'ALERTS.ONBOARDING.TAB_APPLE' | translate">
        <ol class="bv-ical-modal__steps">
          <li>{{ 'ALERTS.ONBOARDING.STEP_APPLE_1' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_APPLE_2' | translate }}</li>
          <li>{{ 'ALERTS.ONBOARDING.STEP_APPLE_3' | translate }}</li>
        </ol>
      </mat-tab>
    </mat-tab-group>

    <p class="bv-ical-modal__note">
      <mat-icon class="bv-ical-modal__note-icon">info</mat-icon>
      <span>{{ 'ALERTS.ONBOARDING.SYNC_NOTE' | translate }}</span>
    </p>
  }

  <footer class="bv-ical-modal__footer">
    <button type="button" class="bv-btn bv-btn--secondary" (click)="onClose()">
      {{ 'BUTTONS.CLOSE' | translate }}
    </button>
  </footer>
</div>
